import { v4 as uuidv4 } from "uuid";


export const chartDataCorrector = (data) => {
    const contractors = data["contractors"];
    const arr = [];
    for (let i in contractors) {
      let t = {
        id: contractors[i]["id"],
        name: contractors[i]["name"],
        q: contractors[i]["crews"].length,
        n: contractors[i]["n"],
        w: contractors[i]["w"],
        r: contractors[i]["r"],
        t: contractors[i]["t"],
        NPT: contractors[i]["NPT"],
        KPI: contractors[i]["KPI"],
      };
      arr.push(t);
    }
    return arr;
  };

  export const topDataCorrector = (data) => {
    //const top = data["top"];
    const arr = [];
    for (let i in data) {
      let t = {
        id: data[i]["violation"]["id"],
        index: parseInt(i)+1,
        reference: data[i]["violation"]["reference"],
        shortText: data[i]["violation"]["shortText"],
        size: data[i]["size"],
      };
      arr.push(t);
    }
    return arr;
  };


export const chartDetailDataCorrector = (selectedCompany, chartId = 0) => {
  const contractors = selectedCompany["contractors"];
  const crews2 = contractors.filter((l) => l.id === chartId);
  let crews = crews2[0]["crews"];
  const arr = [];
  for (let i in crews) {
    let t = {
      id: uuidv4(),
      name: crews[i]["name"],
      n: crews[i]["n"],
      w: crews[i]["w"],
      r: crews[i]["r"],
      t: crews[i]["t"],
      NPT: crews[i]["NPT"],
      KPI: crews[i]["KPI"],
    };
    arr.push(t);
  }
  return arr;
};

export const getContractor = (selectedCompany, chartId) => {
  const contractors = selectedCompany["contractors"];
  const name = contractors.filter((l) => l.id === chartId)[0]["name"];
  return name;
};

export const idGenerator = (data) => {
    for (let obj of data) {
      obj["id"] = uuidv4();
      for (let item of obj["contractors"]) {
        item["id"] = uuidv4();
        for (let crew of item["crews"]) {
          crew["id"] = uuidv4();
        }
      }
    }
    return data;
  };

const AGO_DAYS = 30;